import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-dec-img-import-steps',
  templateUrl: './dec-img-import-steps.component.html',
  styleUrls: ['./dec-img-import-steps.component.scss']
})
export class DecImgImportStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
